import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import CardItem from "./CardItem";

const Cuadricula = props => {
  const { classes, productos, isLogged, programLogo } = props;

  return (
    <div className={classes.container}>
      <Grid
        container
        direction="row"
        alignItems="stretch"
        spacing={16}
        className={classes.gridContainer}
      >
        {productos.map(producto => (
          <CardItem
            isLogged={isLogged}
            key={`catalogo-${producto.idProducto}`}
            producto={producto}
            classes={classes}
            programLogo={programLogo}
          />
        ))}
      </Grid>
    </div>
  );
};

Cuadricula.propTypes = {
  productos: PropTypes.array,
  classes: PropTypes.object
};

Cuadricula.defaultProps = {};

export default Cuadricula;
